import React, { useContext } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import PdpOurPromise from "../pdp-our-promise";
import ProductImagesSlider from "components/product-images/slider";
import PdpVariations from "../pdp-variations";
import GlobalContext from "services/global-context";
import {
  container, contentCol,
  imagesCol,
  contentColSticky, isDesktop, isMobile
} from "./style.mod.scss";
import ProductContext from "services/product-context";
import PDPAccordions from "components/pdp-accordions";

const EnhancedPDPLayout = ({ reviewSummary, settings, product, currentVariant }) => {
  const { addToCart } = useContext(GlobalContext);
  const productContext = useContext(ProductContext);
  if (!productContext) return <></>;

  const { handle, content: content } = productContext;
  const urls = content?.productLink;
  const pdpLayout = content?.layout;
  const productHighlights = content?.enhancedPDP?.productHighlights;

  return (
    <div className={`${container} container-wide`}>
      <Row>
        <Col lg={7} className={imagesCol}>
          <ProductImagesSlider
            currentVariant={currentVariant}
            content={content}
            reviewSummary={reviewSummary}
            enhancedPDP={pdpLayout === "enhanced"}
          />
          <div className={isDesktop}>
            {currentVariant?.variantAccordions?.map((item, i) => (<PDPAccordions item={item} key={i} />))}
            <PdpOurPromise
              variant={currentVariant}
              handle={handle}
              color={productContext?.content?.bgColor}
              enhancedPDP={pdpLayout === "enhanced"}
              productHighlights={productHighlights}
            />
          </div>
        </Col>
        <Col lg={4} className={contentCol}>
          <div className={contentColSticky}>
            <PdpVariations
              linkedProducts={urls}
              currentVariant={currentVariant}
              onAddToCart={addToCart}
              reviewSummary={reviewSummary}
              settings={settings}
              content={content}
              product={product}
              enhancedPDP={pdpLayout === "enhanced"}
              enhancedPDPContent={content?.enahncedPDP}
            />
            <div className={isMobile}>
              <PdpOurPromise
                variant={currentVariant}
                handle={handle}
                color={productContext?.content?.bgColor}
                enhancedPDP={pdpLayout === "enhanced"}
                productHighlights={productHighlights}
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default EnhancedPDPLayout;

